import { thunkSignIn } from 'domain/env/effects';
import { Formik } from 'formik';
import { email, password } from 'libs/validations';
import React, { FunctionComponent, useCallback } from 'react';
import { useDispatch, useMappedState } from 'redux-react-hook';
import { createStructuredSelector } from 'reselect';
import { envErrorMessagesSelector, envIsErrorSelector } from 'domain/env/selectors';
import * as Yup from 'yup';
import Form from './Form';
import { useNavigate } from 'react-router-dom';

const SignInSchema = Yup.object().shape({
  email,
  password,
});

interface ISignIn {
  className?: string;
}

export interface ISignInFormValues {
  email: string;
  password: string;
  remember: boolean;
}

const SignIn: FunctionComponent<ISignIn> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selector = createStructuredSelector({
    isError: envIsErrorSelector,
    errorMessage: envErrorMessagesSelector,
  });

  const { errorMessage } = useMappedState(selector);

  const onSubmit = useCallback(
    (values: ISignInFormValues) => {
      dispatch(thunkSignIn(values, navigate));
    },
    [navigate]
  );

  return (
    <Formik
      initialValues={{ email: '', password: '', remember: true }}
      onSubmit={onSubmit}
      validationSchema={SignInSchema}
    >
      {(formikProps) => <Form {...formikProps} error={errorMessage} />}
    </Formik>
  );
};

export default SignIn;
